import { Box } from "@mui/material";
import React from "react";

const NotFoundPage = () => {
  return <Box>No se encontro lo que buscaba</Box>;
};

export default NotFoundPage;
